"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react2 = require("@prismicio/react");

var _PrismicHtmlSerializer = _interopRequireDefault(require("../../../htmlSerializer/PrismicHtmlSerializer"));

var _MarkdownLinkRenderer = _interopRequireDefault(require("../../../shared/components/MarkdownRenderers/MarkdownLinkRenderer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SectionBorderTile = function SectionBorderTile(_ref) {
  var _ref$sliceData$primar = _ref.sliceData.primary,
      borderColor = _ref$sliceData$primar.border_tile_border_color,
      image = _ref$sliceData$primar.border_tile_image,
      title = _ref$sliceData$primar.border_tile_title,
      body = _ref$sliceData$primar.border_tile_body,
      buttonType = _ref$sliceData$primar.border_tile_button_type,
      buttonCopy = _ref$sliceData$primar.border_tile_button_copy,
      _ref$sliceData$primar2 = _ref$sliceData$primar.border_tile_button_link,
      url = _ref$sliceData$primar2.url,
      target = _ref$sliceData$primar2.target;
  var borderColorPrefix = borderColor.slice(0, 1) === '#' ? '' : '#';
  var buttonClasses = (0, _classnames["default"])('content-page__border-tile-button', {
    'content-page__border-tile-button--solid-green': buttonType === 'Solid Green',
    'content-page__border-tile-button--solid-blue': buttonType === 'Solid Blue',
    'content-page__border-tile-button--hollow-blue': buttonType === 'Hollow Blue'
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__border-tile",
    style: {
      'border-color': "".concat(borderColorPrefix).concat(borderColor)
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__border-tile-image"
  }, /*#__PURE__*/_react["default"].createElement(_react2.PrismicImage, {
    field: image
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__border-tile-text"
  }, /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
    baseClass: "content-page__rich-text",
    content: title
  }), /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
    baseClass: "content-page__rich-text",
    content: body
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__border-tile-cta"
  }, /*#__PURE__*/_react["default"].createElement(_MarkdownLinkRenderer["default"], {
    className: buttonClasses,
    href: url,
    title: buttonCopy,
    external: target === '_blank'
  }, buttonCopy))));
};

SectionBorderTile.propTypes = {
  sliceData: _propTypes["default"].shape({
    primary: _propTypes["default"].shape({
      border_tile_border_color: _propTypes["default"].string,
      border_tile_image: _propTypes["default"].shape({}),
      border_tile_title: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
      border_tile_body: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
      border_tile_button_type: _propTypes["default"].string,
      border_tile_button_copy: _propTypes["default"].string,
      border_tile_button_link: _propTypes["default"].shape({
        url: _propTypes["default"].string,
        target: _propTypes["default"].string
      })
    }).isRequired
  }).isRequired
};
var _default = SectionBorderTile;
exports["default"] = _default;